import axios from 'axios';

export default {
  namespaced: true,
  actions: {
    getSettings() {
      return axios.post('/insurance/clara-ai/settings/detail', {});
    },
    saveSettings({ commit }, settings) {
      return axios.post('/insurance/clara-ai/settings/save', settings);
    },
    toggleEnable({ commit }, enabled) {
      return axios.post('/insurance/clara-ai/toggle', { enabled });
    },
    listSources({ commit }, params) {
      return axios.post('/insurance/clara-ai/source/list', params);
    },
    saveSource({ commit }, source) {
      return axios.post('/insurance/clara-ai/source/save', source);
    },
    deleteSource({ commit }, id) {
      return axios.post('/insurance/clara-ai/source/delete', { id });
    },
    getPerformanceMetrics({ commit }, params) {
      return axios.post('/insurance/clara-ai/performance/detail', params || {});
    },
    escalateTicket({ commit }, ticketId) {
      return axios.post('/insurance/clara-ai/ticket/escalate', { ticketId });
    },
    sendDraft({ commit }, {
      ticketId, text, channelType, insuranceChannelId
    }) {
      return axios.post('/insurance/clara-ai/draft/send', {
        ticketId, text, channelType, insuranceChannelId
      });
    },
    rejectDraft({ commit }, { ticketId }) {
      return axios.post('/insurance/clara-ai/draft/reject', { ticketId });
    },
    // REN-1258 — deterministic by-agent "Communication review" worklist.
    // `scope: 'self'` lets a manager narrow it to their own book (reps are always self-scoped).
    getCommunicationReview({ commit }, { scope } = {}) {
      return axios.post('/insurance/clara-ai/communication-review/detail', scope ? { scope } : {});
    },
    // Inline "Reply" action — reuses the conversation send endpoint; the worklist item's chatId is
    // the conversationId. Used to clear unanswered / slow-first-response / quote-follow-up flags.
    sendCommunicationReply({ commit }, { conversationId, text }) {
      return axios.post('/insurance/conversation/message/send', { conversationId, text });
    },
  },
};
